import { Button, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the view button
 * 
 * @param {Object} props The props of the component
 * @returns The view button
 */
const ViewButton = ({ children, icon, isSelected, title, ...props }) => (
  <Button
    height={"50px"}
    backgroundColor={isSelected ? "#1F9FFF22" : "#FFFFFF11"}
    color={"white"}
    padding={0}
    margin={0}
    _hover={{
      backgroundColor: "#1F9FFF11"
    }}
    _active={{
      backgroundColor: "#1F9FFF22"
    }}
    {...props}
  >
    <VStack padding={0} whiteSpace={"normal"} width={"full"}>
      {icon && <Icon as={icon} boxSize={8} padding={0} />}
      {title && <Text wordBreak={"keep-all"}>{title}</Text>}
    </VStack>
    {children}
  </Button>
);

export default React.memo(ViewButton);
